import React, { Component } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import {
  addMediaBuyerPlan,
  deleteMediaBuyerPlan,
  getFilteredPlans,
  getMediaBuyerProfit,
  getPlans,
  initMediaBuyerPlans,
  patchMediaBuyerPlansFilterData,
  setMediaBuyerPlansNesting,
  closeEditCustomProfit,
  editCustomProfit,
  addMediaBuyerVoucher,
  updateMediaBuyerVoucher,
  // getPayoutConditions,
  deletePayoutCondition,
  updatePayoutCondition,
  addPayoutCondition,
  mediaBuyerVoucherUpdateTrigger
} from "../../../store/mediabuyers/mediabuyerplans/actions";
import { getMediaBuyerDataForAdd } from "../../../store/mediabuyers/mediabuyerbudget/actions";
import { getOffers } from "../../../store/offers/actions";
import { getCampaignMediaBuyersList } from "../../../store/campaigns/media-buyers/actions";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import queryString from "query-string";
import {
  changeQuery,
  getSelectedMonthAgoWithFirstDay,
  getSelectedMonthAgoWithLastDay,
} from "../../../helpers/utils";
import MediaBuyingPlansProfit from "./MediaBuyingPlansProfitTable";
import PlansPayoutsMediaBuyer from "./PlansPayoutsMediaBuyer";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

const QUERY_KEYS = ["offer", "page", "ordering", "search", "sizePerPage"];

class MediaBuyerPlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      deleteAlert: null,
      viewAddBudget: false,
      activeTab: "overview",
      isAdmin: false,
    };

    this.searchTimer = null;
    this.toggle = this.toggle.bind(this);
  }

  getQuery = () => {
    const parsed = queryString.parse(window.location.search);
    for (let key in parsed) {
      if (!QUERY_KEYS.some(i => i === key)) {
        delete parsed.key;
      }
    }
    return parsed;
  };

  componentDidMount() {
    //    const init_data = this.getQuery();
    const { permissions } = this.props;

    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_admin"] ||
      permissions["is_viewer"] ||
      permissions["is_hr"]
    ) {
      this.props.getMediaBuyerProfit({
        date_from: getSelectedMonthAgoWithFirstDay(0),
        date_to: getSelectedMonthAgoWithLastDay(-1),
        for_yourself: false,
      });
      this.setState({
        isAdmin: true,
      });
    } else {
      this.props.getMediaBuyerProfit({
        date_from: getSelectedMonthAgoWithFirstDay(0),
        date_to: getSelectedMonthAgoWithLastDay(-1),
        for_yourself: true,
      });
    }

    // if (
    //   permissions["is_head_of_mediabuyer"] ||
    //   permissions["is_admin"] ||
    //   permissions["is_viewer"] || permissions["is_hr"]
    // ) {
    //   this.props.getPayoutConditions({
    //     ...this.props.payoutData,
    //   });
    // }

    let offer_data = this.props.offers;
    offer_data["sizePerPage"] = 25;
    const hash = this.props.location.hash.split("#").join("") || "overview";
    this.props.history.location.hash = hash;
    this.toggle(hash);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.hash !== this.props.location.hash) {
      this.handleUpdateTab();
    }
  }

  handleUpdateTab = () => {
    const hash = this.props.location.hash.split("#").join("") || "overview";
    this.toggle(hash);
  };

  handleTableChange = data => {
    changeQuery(data);
    this.props.getPlans({
      ...data,
      offer: this.getQuery()?.offer,
    });
  };

  handleOverviewTableChange = data => {
    this.props.offers.page = data.page;
    this.props.offers.sizePerPage = data.sizePerPage;
    this.props.getOffers({
      ...this.props.offers,
      is_main: false,
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddBudgetModal = () => {
    this.setState(prevState => ({
      viewAddBudget: !prevState.viewAddBudget,
    }));
  };

  onClickRow = item => {
    if ("offer" in this.getQuery()) return void 0;

    this.props.setMediaBuyerPlansNesting(item);
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  onChangeOverviewFilterData = data => {
    const { permissions } = this.props;
    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_admin"] ||
      permissions["is_viewer"]  || permissions["is_hr"]
    ) {
      this.props.getMediaBuyerProfit(data);
    } else {
      if (permissions["view_mediabuyer_dashboard_for_yourself"]) {
        this.props.getMediaBuyerProfit({
          ...data,
          for_yourself: true,
        });
      } else {
        this.props.getMediaBuyerProfit(data);
      }
    }
  };

  handleTableChange = data => {
    const { permissions, profitFilterData, getMediaBuyerProfit } = this.props;
    const params = {
      date_from: profitFilterData.date_from,
      date_to: profitFilterData.date_to,
      ordering: data.ordering,
    };
    
    const hasAdminAccess = permissions["is_head_of_mediabuyer"] || 
                           permissions["is_admin"] || 
                           permissions["is_viewer"] || 
                           permissions["is_hr"];
    
    const forYourself = !hasAdminAccess && permissions["view_mediabuyer_dashboard_for_yourself"];
    
    getMediaBuyerProfit(forYourself ? { ...params, for_yourself: true } : params);
  }

  render() {
    const { permissions } = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Plans | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Plans"
              link="/dashboard"
            />

            <Row>
              <Col sm="col-12">
                <Card className="mb-0">
                  <CardBody>
                    <Nav
                      tabs
                      className="nav-tabs-custom"
                      style={{
                        width: "80%",
                        borderBottom: "0",
                      }}
                    >
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{ hash: "overview" }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "overview",
                          })}
                          onClick={() => {
                            this.toggle("overview");
                          }}
                        >
                          Overview
                        </Link>
                      </NavItem>
                     {/* {(permissions["is_head_of_mediabuyer"] ||
                        permissions["is_admin"] ||
                        permissions["is_viewer"]) && (
                          <NavItem>
                            <Link
                              style={{ cursor: "pointer" }}
                              to={{ hash: "payout-conditions" }}
                              className={classnames("nav-link", {
                                active:
                                  this.state.activeTab === "payout-conditions",
                              })}
                              onClick={() => {
                                this.toggle("payout-conditions");
                              }}
                            >
                              Payout conditions
                            </Link>
                          </NavItem>
                        )} */}
                    </Nav>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <TabContent
            activeTab={this.state.activeTab}
            className="text-muted"
            style={{ padding: "40px 12px 0px 12px" }}
          >
            <TabPane tabId="overview">
              <Row>
                <Col className="col-12">
                  <MediaBuyingPlansProfit
                    profit_data={this.props.profit_data}
                    profit_loading={this.props.profit_loading}
                    handleOverviewTableChange={this.handleOverviewTableChange}
                    loading_offer_data={this.props.loading_offer_data}
                    permissions={this.props.permissions}
                    filterData={this.props.profitFilterData}
                    onChange={this.onChangeOverviewFilterData}
                    handleTableChange={this.handleTableChange}
                    closeEditCustomProfit={this.props.closeEditCustomProfit}
                    editCustomProfit={this.props.editCustomProfit}
                    addMediaBuyerVoucher={this.props.addMediaBuyerVoucher}
                    updateMediaBuyerVoucher={this.props.updateMediaBuyerVoucher}
                    mediaBuyerVoucherUpdateTrigger={this.props.mediaBuyerVoucherUpdateTrigger}
                  />
                </Col>
              </Row>
            </TabPane>
            {/* {(permissions["is_head_of_mediabuyer"] ||
              permissions["is_admin"] ||
              permissions["is_viewer"]) && (
                <TabPane tabId="payout-conditions">
                  <Row>
                    <Col className="col-12">
                      <PlansPayoutsMediaBuyer
                        isAdmin={this.state.isAdmin}
                        getPayoutConditions={this.props.getPayoutConditions}
                        deletePayoutCondition={this.props.deletePayoutCondition}
                        updatePayoutCondition={this.props.updatePayoutCondition}
                        addPayoutCondition={this.props.addPayoutCondition}
                        data={this.props.payoutData}
                        loader={this.props.payout_loader}
                        permissions={this.props.permissions}
                      />
                    </Col>
                  </Row>
                </TabPane>
              )} */}
          </TabContent>
        </div>
      </React.Fragment>
    );
  }
}

MediaBuyerPlans.propTypes = {
  data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  profit_data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  offers: PropTypes.shape({
    sizePerPage: PropTypes.number,
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  profitFilterData: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  offer: PropTypes.object,
  filterData: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  loading_offer_data: PropTypes.bool.isRequired,
  profit_loading: PropTypes.bool.isRequired,
  getOffers: PropTypes.func.isRequired,
  addMediaBuyerPlan: PropTypes.func.isRequired,
  getFilteredPlans: PropTypes.func.isRequired,
  setMediaBuyerPlansNesting: PropTypes.func.isRequired,
  initMediaBuyerPlans: PropTypes.func.isRequired,
  patchMediaBuyerPlansFilterData: PropTypes.func.isRequired,
  getCampaignMediaBuyersList: PropTypes.func.isRequired,
  getMediaBuyerProfit: PropTypes.func.isRequired,
  getPlans: PropTypes.func.isRequired,
  deleteMediaBuyerPlan: PropTypes.func.isRequired,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  closeEditCustomProfit: PropTypes.func.isRequired,
  editCustomProfit: PropTypes.func.isRequired,
  addMediaBuyerVoucher: PropTypes.func.isRequired,
  updateMediaBuyerVoucher: PropTypes.func.isRequired,
  payoutData: PropTypes.object.isRequired,
  payout_loader: PropTypes.bool.isRequired,
  // getPayoutConditions: PropTypes.func.isRequired,
  deletePayoutCondition: PropTypes.func.isRequired,
  updatePayoutCondition: PropTypes.func.isRequired,
  addPayoutCondition: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  mediaBuyerVoucherUpdateTrigger: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  filterData: state.MediaBuyerPlans.filterData,
  payoutData: state.MediaBuyerPlans.payoutData,
  payout_loader: state.MediaBuyerPlans.payout_loader,
  offers: state.Offers.offers,
  loading_offer_data: state.Offers.loading_offer_data,
  data: state.MediaBuyerPlans.data,
  offer: state.MediaBuyerPlans.offer,
  loading: state.MediaBuyerPlans.loading,
  permissions: state.User.permissions,
  user: state.User.user_settings,
  profit_data: state.MediaBuyerPlans.profit_data,
  profit_loading: state.MediaBuyerPlans.profit_loading,
  profitFilterData: state.MediaBuyerPlans.profitFilterData,
});

export default connect(mapStateToProps, {
  getPlans,
  deleteMediaBuyerPlan,
  getMediaBuyerDataForAdd,
  getCampaignMediaBuyersList,
  addMediaBuyerPlan,
  getFilteredPlans,
  getOffers,
  initMediaBuyerPlans,
  setMediaBuyerPlansNesting,
  getMediaBuyerProfit,
  patchMediaBuyerPlansFilterData,
  closeEditCustomProfit,
  editCustomProfit,
  addMediaBuyerVoucher,
  updateMediaBuyerVoucher,
  // getPayoutConditions,
  deletePayoutCondition,
  updatePayoutCondition,
  addPayoutCondition,
  mediaBuyerVoucherUpdateTrigger
})(MediaBuyerPlans);
